import { api } from "./api";

export interface AzureMarketplaceSubscription {
  id: string;
  name: string;
  planId: string;
  offerId: string;
  saasSubscriptionStatus: string;
  quantity: string;
  beneficiary: {
    emailId: string;
    tenantId: string;
  };
  term: {
    startDate: string;
    endDate: string;
    termUnit: string;
  };
  autoRenew: boolean;
  isFreeTrial: boolean;
}

export interface AzureMarketplacePlan {
  planId: string;
  displayName: string;
  isPrivate: boolean;
}

export interface AzureUsageInfo {
  currentMonthUsage: number;
  dimension: string;
  lastUpdated: string;
  subscriptionId: string;
  status: string;
}

export const azureMarketplaceService = {
  async getSubscription(): Promise<AzureMarketplaceSubscription | null> {
    try {
      const response = await api.get("/marketplace/azure/subscription");
      console.log("[azureMarketplaceService] getSubscription response:", {
        status: (response as any)?.status,
        data: (response as any)?.data,
      });
      const body = (response as any)?.data || response;
      const payload = body?.data ?? body?.Data ?? null;
      return payload;
    } catch (error) {
      console.error("Error fetching Azure subscription:", error);
      return null;
    }
  },

  async getAvailablePlans(): Promise<AzureMarketplacePlan[]> {
    try {
      const response = await api.get("/marketplace/azure/plans");
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching available plans:", error);
      return [];
    }
  },

  async linkSubscription(subscriptionId: string): Promise<boolean> {
    try {
      console.log("[azureMarketplaceService] Linking subscription - request:", {
        subscriptionId,
        url: "/marketplace/azure/link",
      });
      const response = await api.post("/marketplace/azure/link", {
        subscriptionId,
      });
      console.log(
        "[azureMarketplaceService] Linking subscription - response:",
        {
          status: (response as any)?.status,
          data: (response as any)?.data,
        }
      );
      return response.data.success;
    } catch (error) {
      console.error("[azureMarketplaceService] Error linking subscription:", {
        message: (error as any)?.message,
        status: (error as any)?.response?.status,
        statusText: (error as any)?.response?.statusText,
        data: (error as any)?.response?.data,
        url: (error as any)?.config?.url,
      });
      return false;
    }
  },

  async resolveToken(
    token: string
  ): Promise<AzureMarketplaceSubscription | null> {
    try {
      console.log("Calling API to resolve token...");
      const response = await api.post("/marketplace/azure/resolve", {
        marketplaceToken: token,
      });
      console.log("API response:", response.data);
      return response.data.data;
    } catch (error: any) {
      console.error("Error resolving token:", {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url,
      });
      return null;
    }
  },

  async getCurrentUsage(): Promise<AzureUsageInfo | null> {
    try {
      const response = await api.get("/marketplace/azure/usage");
      return response.data.data;
    } catch (error) {
      console.error("Error fetching current usage:", error);
      return null;
    }
  },

  // Check if we're in Azure deployment mode
  isAzureDeployment(): boolean {
    // This can be determined from environment variables or API config
    return (
      window.location.hostname.includes("azure") ||
      import.meta.env.VITE_DEPLOYMENT_TYPE === "azure"
    );
  },
};
